import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import ResizeObserver from 'resize-observer-polyfill'
import { Mainframe } from '@walltowall/mainframe'

import { Button } from './Button'

import { Box, Flex } from 'system'

const frameWidths = {
  mobile: 360,
  tablet: 768,
  desktop: 2000,
}

export const SliceExamples = ({ children }) => {
  const [size, setSize] = useState('mobile')
  const frameWidth = frameWidths[size]

  return (
    <Box>
      <Flex my={4} justifyContent="center">
        <Button mr={2} fontSize="small" onClick={() => setSize('desktop')}>
          Desktop
        </Button>
        <Button fontSize="small" onClick={() => setSize('tablet')}>
          Tablet
        </Button>
        <Button ml={2} fontSize="small" onClick={() => setSize('mobile')}>
          Mobile
        </Button>
      </Flex>
      {React.Children.map(
        children,
        child =>
          child && React.cloneElement(child, { targetWidth: frameWidth }),
      )}
    </Box>
  )
}

export const Example = Mainframe

SliceExamples.Example = Example
